// move the position of the tooltip if it hits the edges of the page
export var movePositionWithinContainer = function (innerWidth, innerHeight) { return function (box) {
    if (box.left < 0) {
        box.left = 0;
    }
    if (box.left + box.minWidth > innerWidth) {
        box.left = innerWidth - box.minWidth;
    }
    if (box.top < 0) {
        box.top = 0;
    }
    if (box.top > innerHeight) {
        box.top = innerHeight;
    }
    return box;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/utils/tooltip/movePositionWithinContainer.ts
// module id = 1130
// module chunks = 3